import { render } from "./IconChevronSmall.vue?vue&type=template&id=e08bef8a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconChevronSmall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e08bef8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e08bef8a', __exports__)) {
    api.reload('e08bef8a', __exports__)
  }
  
  module.hot.accept("./IconChevronSmall.vue?vue&type=template&id=e08bef8a", () => {
    api.rerender('e08bef8a', render)
  })

}


export default __exports__